var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 350 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 10h333v230H8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF7D00",
    d: "M340.552 228.124V147.7s-90.309 63.72-255.714 92.256h237.636c10.155-.312 16.083-3.62 18.078-11.833z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#discover_card_logo_paint0_radial)",
    d: "M24.577 0C11.009 0 0 10.6 0 23.682 0 37.59 10.53 47.987 24.577 47.987c13.696 0 24.509-10.535 24.509-24.032C49.086 10.537 38.345 0 24.576 0z",
    transform: "translate(159.813 83.45)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#05171D",
    fillRule: "evenodd",
    d: "M31.652 84.314h13.213c14.571 0 24.735 9.459 24.736 23.064 0 6.785-3.114 13.348-8.363 17.702-4.425 3.664-9.468 5.316-16.442 5.316H31.652V84.314zm11.41 38.282c5.812 0 9.47-1.108 12.31-3.67 3.11-2.754 4.964-7.185 4.964-11.614 0-4.42-1.854-8.7-4.964-11.465-2.98-2.692-6.498-3.73-12.31-3.73h-2.416v30.48h2.416z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#05171D",
    d: "M73.749 84.314h8.979v46.082h-8.98V84.314zm30.963 17.677c-5.398-2-6.985-3.318-6.985-5.796 0-2.905 2.827-5.114 6.703-5.114 2.694 0 4.906 1.104 7.263 3.722l4.692-6.14c-3.869-3.393-8.498-5.118-13.547-5.118-8.146 0-14.37 5.668-14.37 13.194 0 6.363 2.9 9.607 11.333 12.656 3.527 1.237 5.32 2.062 6.22 2.627 1.797 1.174 2.698 2.826 2.698 4.76 0 3.737-2.974 6.498-6.987 6.498-4.284 0-7.737-2.14-9.81-6.147l-5.798 5.603c4.137 6.073 9.114 8.776 15.961 8.776 9.329 0 15.89-6.228 15.89-15.138 0-7.327-3.032-10.646-13.263-14.383zm16.095 5.387c0 13.558 10.644 24.059 24.331 24.059 3.87 0 7.187-.765 11.267-2.692v-10.577c-3.597 3.595-6.777 5.043-10.856 5.043-9.05 0-15.481-6.567-15.481-15.9 0-8.84 6.632-15.821 15.07-15.821 4.278 0 7.532 1.52 11.267 5.182V86.094c-3.939-1.997-7.192-2.82-11.062-2.82-13.617 0-24.536 10.713-24.536 24.104zm108.43 7.892l-12.3-30.956h-9.815l19.564 47.261h4.833l19.906-47.261h-9.741l-12.447 30.955zm26.274 15.127h25.497v-7.8h-16.514v-12.448h15.882v-7.804h-15.882V92.118h16.514v-7.804H255.51v46.083z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#05171D",
    fillRule: "evenodd",
    d: "M300.282 84.314c10.371 0 16.306 4.967 16.306 13.6 0 7.054-3.725 11.685-10.508 13.072l14.522 19.411h-11.058l-12.433-18.52h-1.176v18.52h-8.993V84.314h13.34zm-4.347 21.211h2.615c5.754 0 8.793-2.497 8.793-7.123 0-4.484-3.04-6.84-8.649-6.84h-2.759v13.963z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    fillRule: "evenodd",
    d: "M321.4 86.5c.989 0 1.528.438 1.528 1.246 0 .565-.314.985-.883 1.136l1.35 1.678h-1.205l-1.136-1.579v1.579h-.962V86.5h1.308zm-.346 1.798h.18c.477 0 .73-.18.731-.537 0-.345-.243-.519-.722-.519h-.189v1.056z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    fillRule: "evenodd",
    d: "M318.05 88.519a3.535 3.535 0 0 1 3.544-3.547c1.927 0 3.5 1.603 3.5 3.547 0 1.95-1.573 3.547-3.5 3.547a3.54 3.54 0 0 1-3.544-3.547zm.699.009c0 1.605 1.267 2.902 2.84 2.902 1.53 0 2.791-1.308 2.792-2.902 0-1.596-1.263-2.91-2.791-2.91-1.583 0-2.841 1.289-2.841 2.91z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M112.217 142.51l12.025 12.597v-11.939h1.718v16.11l-12.022-12.57v11.88h-1.721V142.51z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    fillRule: "evenodd",
    d: "M112.056 158.749v-16.643s11.494 12.042 12.023 12.601v-11.703h2.036v16.673l-12.02-12.573v11.645h-2.039zm12.352-3.238s-11.497-12.05-12.03-12.6v15.514h1.403v-12.122s11.484 12.023 12.016 12.582v-15.563h-1.389v12.19z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M134.289 143.167h7.989v1.593h-6.276v4.586h6.093v1.592h-6.093v6.05h6.276v1.598h-7.989v-15.419z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    fillRule: "evenodd",
    d: "M134.125 143.005h8.316v1.926h-6.274v4.257h6.088v1.903h-6.088v5.736h6.274v1.922h-8.316v-15.744zm7.994 1.593v-1.277h-7.673v15.104h7.673v-1.276h-6.28v-6.373h6.094v-1.272h-6.093v-4.906h6.279z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M154.41 158.587h-1.72v-13.826h-3.718v-1.593h9.2v1.593h-3.761v13.826z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    fillRule: "evenodd",
    d: "M148.799 143.005h9.531v1.926h-3.765v13.818h-2.039V144.93H148.8v-1.926zm9.212 1.593v-1.277h-8.879v1.277h3.718v13.826h1.397v-13.826h3.764z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M169.662 154.723l4.992-12.359 4.988 12.359 4.049-11.555h1.868l-5.917 16.213-4.988-12.42-4.992 12.42-5.903-16.213h1.859l4.044 11.555z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    fillRule: "evenodd",
    d: "M169.671 154.266l4.838-11.96.145-.366s4.676 11.587 4.978 12.326c.261-.748 3.946-11.26 3.946-11.26h2.205l-6.137 16.835s-4.713-11.734-4.992-12.443c-.28.709-4.992 12.443-4.992 12.443l-6.138-16.836h2.2l3.947 11.261zm4.983-11.463c-.28.685-4.843 11.978-4.843 11.978l-.158.396-4.154-11.856h-1.514c.154.41 5.416 14.867 5.681 15.612.293-.733 4.988-12.397 4.988-12.397s4.687 11.664 4.979 12.397a9618.49 9618.49 0 0 0 5.69-15.612h-1.519c-.077.213-4.153 11.856-4.153 11.856s-4.718-11.689-4.997-12.374zm25.074 16.05c4.39 0 8.036-3.522 8.036-7.959 0-4.416-3.646-7.991-8.036-7.991-4.403 0-8.036 3.575-8.036 7.991 0 4.437 3.633 7.96 8.036 7.96zm-.001-1.601c-3.5 0-6.323-2.903-6.323-6.378 0-3.497 2.787-6.384 6.323-6.383 3.535 0 6.314 2.886 6.314 6.383 0 3.474-2.816 6.378-6.314 6.378z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    fillRule: "evenodd",
    d: "M199.727 159.011c-4.52 0-8.199-3.643-8.199-8.117 0-4.502 3.679-8.151 8.199-8.151 4.518 0 8.197 3.65 8.197 8.151 0 4.474-3.68 8.117-8.197 8.117zm0-15.946c-4.347 0-7.883 3.508-7.883 7.83 0 4.3 3.535 7.796 7.883 7.796 4.34 0 7.883-3.496 7.883-7.797 0-4.32-3.545-7.83-7.883-7.83z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    fillRule: "evenodd",
    d: "M199.728 157.416c-3.572 0-6.486-2.922-6.486-6.541 0-3.606 2.914-6.538 6.486-6.538 3.57 0 6.47 2.932 6.47 6.538 0 3.619-2.9 6.54-6.47 6.54zm0-12.76c-3.4 0-6.16 2.793-6.16 6.219 0 3.428 2.76 6.224 6.16 6.224 3.4 0 6.15-2.795 6.15-6.224 0-3.425-2.751-6.218-6.15-6.218zm15.485 13.931h1.713v-6.772h.435l4.653 6.773h2.109l-4.905-6.913c2.377-.203 3.86-1.881 3.86-4.254 0-3.472-2.715-4.253-5.638-4.253h-2.227v15.42zm2.247-8.284h-.534v-5.543h.514c2.063 0 3.925.253 3.925 2.782 0 2.395-1.967 2.76-3.905 2.76z",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    fillRule: "evenodd",
    d: "M215.051 143.006h.161v-.001h2.228c3.905 0 5.8 1.44 5.8 4.415 0 2.373-1.479 4.036-3.753 4.348.245.357 4.952 6.982 4.952 6.982h-.317l-2.236-.073s-4.533-6.584-4.533-6.701h-.264v6.774h-2.038v-15.744zm7.868 4.414c0-2.794-1.745-4.098-5.48-4.098 0 0-1.792 0-2.07-.002v15.104h1.394v-6.77h.162l.56.07s4.532 6.583 4.532 6.7h1.8l-4.899-6.881.285-.027c2.26-.19 3.716-1.803 3.716-4.096z",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    fillRule: "evenodd",
    d: "M216.764 144.598h.676c1.977 0 4.086.225 4.086 2.945 0 2.583-2.173 2.917-4.067 2.917h-.695v-5.862zm4.437 2.945c0-2.422-1.781-2.611-3.76-2.611h-.352v5.204h.37c1.853 0 3.742-.307 3.742-2.593z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M239.69 143.167H242l-7.238 7.184 7.481 8.235h-2.372l-6.321-7.075-.43.42v6.655h-1.72v-15.419h1.719v6.603l6.57-6.603z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    fillRule: "evenodd",
    d: "M239.628 143.005h2.754s-7.183 7.13-7.408 7.351c.212.217 7.64 8.394 7.64 8.394h-.37l-2.49-.055s-5.998-6.72-6.215-6.954l-.007.007c-.102.097-.228.218-.245.21v6.79h-2.038v-15.743h2.038v6.382c.496-.514 6.34-6.382 6.34-6.382zm-5.09 7.338s6.556-6.503 7.07-7.022h-1.855c-.09.095-6.79 6.843-6.79 6.843v-6.843h-1.393v15.103h1.392c0-.306.045-6.6.045-6.6l.551-.551.108.13s6.206 6.94 6.206 7.021h2.01c-.455-.505-7.345-8.081-7.345-8.081z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E7E7",
    fillRule: "evenodd",
    d: "M30 0h290c16.6 0 30 13.4 30 30v190c0 16.6-13.4 30-30 30H30c-16.6 0-30-13.4-30-30V30C0 13.4 13.4 0 30 0zm310 30c0-11-9-20-20-20H30c-11 0-20 9-20 20v190c0 11 9 20 20 20h290c11 0 20-9 20-20V30z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "discover_card_logo_paint0_radial",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(48.5394 0 0 47.4531 .274 .267)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#FFF2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#FEEDDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    stopColor: "#FDE1C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FACD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#F6B168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F08E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7D00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.a32db3963a21f14474387d9598329a48.svg";
export { ForwardRef as ReactComponent };